import styled from "styled-components/native";
import { light_black, spacing_s } from "../../StyleHelpers";

export const StyledWrapper = styled.View`
	z-index: -1;
	top: 15vh;
	overflow: hidden;
	margin: 0 14.1% 70px 14.1%;
`;

export const StyledButtonContainer = styled.View`
	flex-direction: column;
	width: 71.8%;
	position: absolute;
	bottom: 10%;
	margin: 0 14.1% 0 14.1%;
	gap: 1.5rem;
`;

export const StyledFormContainer = styled.View`
	margin-top: 82px;
	flex-direction: column;
	width: 100%;
	gap: 10px;
`;

export const StyledButtonMainContainer = styled.View`
	display: flex;
	flex-direction: row;
	gap: ${spacing_s};
`;

export const StyledContainer = styled.View`
	background-color: ${light_black};
	height: 100%;
`;

export const StyledTextField = styled.View`
	margin-top: 1.5%;
	margin-bottom: 8%;
`;

export const StyledButton = styled.View`
	position: relative;
`;

/*Narrow*/
export const StyledButtonsContainer = styled.View`
	display: flex;
	width: 31.25rem;
	flex-direction: column;
	align-items: flex-start;
	gap: ${spacing_s};
	align-self: stretch;
`;

export const StyledButtonsWrapper = styled.View`
	display: flex;
	flex-direction: column;
	// align-items: flex-start;
	gap: ${spacing_s};
	align-self: stretch;
`;

export const StyledNarrowTextInput = styled.View`
	display: flex;
	flex-direction: column;
	gap: ${spacing_s};
	flex: 1 0 0;
`;

export const StyledNarrowTextContainer = styled.View`
	margin-top: -6px;
`;
